// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInGuestStyles } from "@awc/App/Widgets/SignIn/SignInGuest";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xScreen } from "@awc/XDL/Utilities";
import { FormFieldIcon } from "@insite/mobius/FormField";
import { css } from "styled-components";

signInGuestStyles.container = {
    gap: 0,
    css: css`
        padding-left: 0;
    `,
};

signInGuestStyles.titleGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-bottom: 12px;
        }
    `,
};

signInGuestStyles.title = {
    variant: "h3",
    as: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

signInGuestStyles.emailGridItem = {
    width: 12,
    css: css`
        margin-bottom: 16px;
    `,
};

signInGuestStyles.form = {
    css: css`
        width: 100%;
    `,
};

signInGuestStyles.buttonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;

        ${xScreen("lte", "sm")} {
            justify-content: stretch;
        }
    `,
};

signInGuestStyles.continueButton = {
    variant: "secondary",
    css: css`
        margin-top: 16px;
        ${({ isFullWidth }: { isFullWidth?: boolean }) =>
            isFullWidth
                ? css`
                      width: 100%;
                  `
                : ""}
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

signInGuestStyles.centeringWrapper = {
    css: css`
        display: flex;
        height: 300px;
        justify-content: center;
        align-items: center;
    `,
};

signInGuestStyles.accountExistsModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalBody: css`
            &&& {
                max-width: 450px;
            }
        `,
    },
};

signInGuestStyles.modalContent = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

signInGuestStyles.modalMessage = {
    css: css`
        margin-bottom: 0;
        max-width: 100%;
    `,
};

signInGuestStyles.modalForm = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
    `,
};

signInGuestStyles.modalPasswordTextField = {
    cssOverrides: {
        formInputWrapper: css`
            ${FormFieldIcon} {
                background: transparent;
            }
        `,
    },
};

signInGuestStyles.modalPasswordIcon = {
    css: css`
        padding-top: 50px;
    `,
};

signInGuestStyles.rememberMeForgotPasswordWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;
        width: 100%;
        gap: 12px;
    `,
};

signInGuestStyles.forgotPasswordLink = {
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
        weight: fontConfig.weight.bold,
    },
    css: css`
        margin-left: auto;
    `,
};

signInGuestStyles.resetPasswordModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalBody: css`
            &&& {
                max-width: 450px;
            }
        `,
    },
};

signInGuestStyles.modalActions = {
    css: css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
        justify-content: flex-end;
        margin-top: 8px;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
            align-items: stretch;
        }
    `,
};

signInGuestStyles.rememberMeCheckboxGroup = {
    css: css`
        margin: 0;
    `,
};

signInGuestStyles.modalSignInButton = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

signInGuestStyles.modalContinueAsGuestButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
